module.exports = __webpack_public_path__ + "static/media/Illumina_dark.89bf3609.png";